<template>
    <div>
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #F3F3F3; padding: 12px 20px">
            <h4 class="mb-0">Mapping History</h4>
            <button class="btn" @click="$emit('closeModal')">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div style="padding: 12px 20px">
            <div>
                <table>
                    <tr>
                        <td style="font-weight: 600;">Nomor Mesin</td>
                        <td style="padding-left: 8px; padding-right: 8px;">:</td>
                        <td>{{ this.engine_no }}</td>
                    </tr>
                    <tr>
                        <td style="font-weight: 600;">Tanggal Mapping Terakhir</td>
                        <td style="padding-left: 8px; padding-right: 8px;">:</td>
                        <td>
                            <span v-if="data.latest_scan_date">{{ formatDate(data.latest_scan_date) }}</span>
                            <span v-else-if="latestHistoryScanDate">{{ formatDate(latestHistoryScanDate) }}</span>
                            <span v-else>-</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="font-weight: 600;">Mapping Times</td>
                        <td style="padding-left: 8px; padding-right: 8px;">:</td>
                        <td>{{ data.total_count || historyData.length }}x</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th style="padding-left: 20px;">No</th>
                        <th>Tanggal Mapping</th>
                        <th>Kode MPM</th>
                        <th>Kode AHM</th>
                        <th>Serial Number</th>
                        <th style="padding-right: 20px;">QR</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td colspan="6" class="text-center">Loading...</td>
                    </tr>
                    <template v-else-if="$store.state.userData.userData.role == 'USER DEALER' && historyData && historyData.length">
                        <tr v-for="(item, idx) in historyData.slice(0, 2)" :key="'dealer-' + idx">
                            <td style="padding-left: 20px;">{{ (config.page - 1) * config.limit + idx + 1 }}</td>
                            <td>{{ formatDate(item.scan_date) }}</td>
                            <td>{{ item.loc_code }}</td>
                            <td>{{ item.ahm_id }}</td>
                            <td>{{ item.serial_number }}</td>
                            <td style="padding-right: 20px;">{{ item.qrcode }}</td>
                        </tr>
                    </template>
                    <template v-else-if="historyData && historyData.length">
                        <tr v-for="(item, idx) in historyData" :key="'history-' + idx">
                            <td style="padding-left: 20px;">{{ (config.page - 1) * config.limit + idx + 1 }}</td>
                            <td>{{ formatDate(item.scan_date) }}</td>
                            <td>{{ item.loc_code }}</td>
                            <td>{{ item.ahm_id }}</td>
                            <td>{{ item.serial_number }}</td>
                            <td style="padding-right: 20px;">{{ item.qrcode }}</td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="10" class="text-center">Tidak ada ditemukan</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+historyData.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['data', 'start_date', 'end_date'],
    data() {
        return {
            historyData: [],
            engine_no: null,
            loading: false,
            config : {
                page: 1,
                limit: 10,
                lastPage: 0,
                total: 0,
            },
        }
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.engine_no) {
                    this.config.page = 1;
                    this.engine_no = newVal.engine_no;
                    this.fetchHistory();
                } else {
                    this.config.page = 1;
                    this.historyData = [];
                }
            }
        },
        'config.page' : {
            deep: true,
            handler: 'fetchHistory'
        },
    },
    computed: {
        latestHistoryScanDate() {
            if (!this.historyData || !this.historyData.length) return null;
            // Find the max scan_date in historyData
            return this.historyData.reduce((max, item) => {
                if (!item.scan_date) return max;
                if (!max) return item.scan_date;
                return moment(item.scan_date).isAfter(max) ? item.scan_date : max;
            }, null);
        }
    },
    methods: {
        goToPage(page) {
            if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
        },
        formatDate(date) {
            return date ? moment(date).format('DD MMM YYYY | HH:mm') : '-';
        },
        fetchHistory() {
            this.loading = true;
            this.$http.get('/api/qrs/mapping-repeat-history', { params: { 
                    engine_no: this.engine_no, start_date: this.start_date, end_date: this.end_date, page: this.config.page, limit: this.config.limit } })
                .then(res => {
                    this.historyData = res.data.data || [];
                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch(() => {
                    this.historyData = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>